import React, { useEffect, useState } from 'react'
import { useAuth } from 'context/AuthProvider';
import ListDepartamentos from './ListDepartamentos';
import { apiDepartamentosService } from 'services/apiDepartamentosService';

const ListDepartamentosImpl = () => {

  const {empresa} = useAuth();
  const [content, setContent] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  
  //const { data, loading, error } = useApi(apiDepartamentosService.getAllPageable(empresa.id,currentPage,10));

  useEffect(() => {
    const fetchData = async () =>{
      const response = await apiDepartamentosService.getAll(empresa.id,currentPage,10);
      setContent(response.content);
      setTotalPage(response.totalPages);
    }
    fetchData();
  }, [currentPage, empresa.id]);

  return (
    <>
   <ListDepartamentos departamentos={content} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPage={totalPage}/>
   </>
  );
}


export default ListDepartamentosImpl